// extracted by mini-css-extract-plugin
export var defaultWrapper = "_h2-3";
export var downloadButton = "_h2-4";
export var fileContainer = "_h2-9 _h2-7";
export var fileContainerBase = "_h2-7";
export var fileContainerBaseSm = "_h2-a _h2-7";
export var fileContainerFixedHeight = "_h2-8 _h2-7";
export var fileContainerFixedHeightSm = "_h2-c _h2-a _h2-7";
export var fileContainerSm = "_h2-b _h2-a _h2-7";
export var fileInfo = "_h2-5";
export var fileInfoWidthRestricted = "_h2-6";
export var fileType = "_h2-1";
export var fileTypeName = "_h2-2";
export var fileTypeSm = "_h2-d _h2-1";
export var image = "_h2-0";
export var link = "_h2-f";
export var overflowEllipsis = "_h2-e";